import React from 'react';

const BoxHeader = ({ id, icon, title, url, blogId, onMouseEnter, onMouseLeave }) => {
    return (
        <a
            className="box-container nolink" 
            href={url}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            id={id}
        >
            <div className="box">
				<img className="box-icon" src={icon} alt={title} />
				{ blogId === 7 && title
					? <p>{title}</p>
					: null
				}
            </div>
        </a>
    )
}

export default BoxHeader;